import Vue from 'vue';
import MenuComponent from '@app/modules/RF/CMS/Menu.vue';
export default Vue.extend({
    data: function () { return ({
        title: 'kleinplakate.ch',
        name: 'WS Kleinplakate GmbH',
        address: 'Wilerstrasse 29',
        plz_ort: 'CH-9602 Bazenheid',
        phone: '+41 79 270 65 55',
        fax: '+41 71 931 32 07',
        email: 'kontakt@kleinplakate.ch'
    }); },
    components: {
        MenuComponent: MenuComponent,
    }
});
